/**
 * Checks for cyclic dependencies on bone parent/child relationship
 * @param {Bone} start
 * @param {Array<Bone>} list
 * @returns {Boolean}
 */
export function hasCyclicDependencies (start, index, list) {
  const stack = [index]
  let current = start
  while (current.parent > -1) {
    if (stack.includes(current.parent)) {
      return true
    }
    stack.push(current.parent)
    current = list[current.parent]
  }
  return false
}

export default {
  hasCyclicDependencies
}
